import React, { useEffect, useState } from 'react'
import { Spinner } from '../Spinner'

export type ImageProps = {
  url: string
  name?: string
  className?: string
  fallbackUrl?: string
  style?: React.CSSProperties
  showLoading?: boolean
}
export const Image = ({ url, name, className = 'img-fluid', fallbackUrl, style, showLoading = false }: ImageProps) => {
  const [imageSrc, setImageSrc] = useState(url)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setImageSrc(url)
    setLoading(true)
  }, [url])

  const onErrorImage = () => {
    const fallback = fallbackUrl ?? 'https://res.cloudinary.com/tmmshauler/image/upload/v1626700322/umbrella/image-not-available.jpg'
    setImageSrc(fallback)
    setLoading(false)
  }

  const onLoadImage = () => {
    setLoading(false)
  }

  const imageNode = (
    <img
      className={`${className}`}
      src={imageSrc}
      title={name}
      alt={name}
      onError={onErrorImage}
      onLoad={onLoadImage}
      style={{
        ...style,
        opacity: loading && showLoading ? 0.5 : 1,
        transition: 'opacity 0.3s ease-in-out',
      }}
    />
  )

  //show loading is false, no need for extra div
  if (!showLoading) {
    return imageNode
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {loading && showLoading && (
        <Spinner
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            zIndex: 1,
          }}
        ></Spinner>
      )}
      {imageNode}
    </div>
  )
}

export type ImagesProps = {
  dataArray?: ImageProps[]
  className?: string
  renderImage?: (m: ImageProps, i: number) => JSX.Element
}
export const Images = ({ dataArray, className, renderImage }: ImagesProps) => {
  if (!dataArray || dataArray.length <= 0) return null

  //setup the default imageItem rendering if not specified
  if (!renderImage) {
    renderImage = (m, i) => {
      return <Image key={i} url={m.url} name={m.name} className={className} />
    }
  }

  return <div>{dataArray.map(renderImage)}</div>
}
